import { combineReducers } from 'redux';

import { machineCsvConstants } from './machineCsv.constants';

const catalogInitial = { data: null, loading: false, error: null };

function catalog(state = catalogInitial, action) {
  switch (action.type) {
    case machineCsvConstants.GET_CSV_CATALOG_REQUEST:
      return { ...state, loading: true, error: null };
    case machineCsvConstants.GET_CSV_CATALOG_SUCCESS:
      return { data: action.catalog, loading: false, error: null };
    case machineCsvConstants.GET_CSV_CATALOG_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}

function exporting(state = false, action) {
  switch (action.type) {
    case machineCsvConstants.EXPORT_CSV_REQUEST:
      return true;
    case machineCsvConstants.EXPORT_CSV_SUCCESS:
    case machineCsvConstants.EXPORT_CSV_FAILURE:
      return false;
    default:
      return state;
  }
}

export const importInitial = {
  requestId: null,
  fileName: null,
  checking: false,
  fileError: null,
  preview: null,
  applying: false,
  applyProblems: null,
  applied: null
};

const RESPONSES = [
  machineCsvConstants.PREVIEW_IMPORT_SUCCESS,
  machineCsvConstants.PREVIEW_IMPORT_FAILURE,
  machineCsvConstants.APPLY_IMPORT_SUCCESS,
  machineCsvConstants.APPLY_IMPORT_FAILURE
];

function importState(state = importInitial, action) {
  // A response to a request that is no longer the current one (the dialog was
  // closed, or another file was chosen) is dropped.
  if (RESPONSES.includes(action.type) && action.requestId !== state.requestId) {
    return state;
  }
  switch (action.type) {
    case machineCsvConstants.PREVIEW_IMPORT_REQUEST:
      return {
        ...importInitial, requestId: action.requestId, fileName: action.fileName, checking: true
      };
    case machineCsvConstants.PREVIEW_IMPORT_SUCCESS:
      return { ...state, checking: false, preview: action.preview };
    case machineCsvConstants.PREVIEW_IMPORT_FAILURE:
      return { ...state, checking: false, fileError: action.fileError };
    case machineCsvConstants.APPLY_IMPORT_REQUEST:
      return {
        ...state, requestId: action.requestId, applying: true, applyProblems: null
      };
    case machineCsvConstants.APPLY_IMPORT_SUCCESS:
      return { ...state, applying: false, applied: action.result };
    case machineCsvConstants.APPLY_IMPORT_FAILURE:
      return { ...state, applying: false, applyProblems: action.problems };
    case machineCsvConstants.RESET_IMPORT:
      return importInitial;
    default:
      return state;
  }
}

export const machineCsvReducer = combineReducers({
  catalog,
  exporting,
  importState
});
